import React from "react";

import {
  FaExclamationTriangle,
  FaSyncAlt,
} from "react-icons/fa";

export default function TutorialErrorState({
  message,
  onRetry,
}) {
  return (
    <div className="flex min-h-[60vh] items-center justify-center">
      <div className="w-full max-w-lg rounded-[28px] border border-rose-200 bg-white p-8 text-center shadow-xl dark:border-rose-900/40 dark:bg-slate-900">
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-[22px] bg-rose-100 text-2xl text-rose-600 dark:bg-rose-500/15 dark:text-rose-300">
          <FaExclamationTriangle />
        </div>

        <h2 className="mt-5 text-xl font-bold text-slate-900 dark:text-white">
          Chargement impossible
        </h2>

        <p className="mt-2 text-sm leading-6 text-slate-500 dark:text-slate-400">
          {message}
        </p>

        <button
          type="button"
          onClick={onRetry}
          className="mt-6 inline-flex items-center gap-2 rounded-2xl bg-violet-600 px-5 py-3 text-sm font-semibold text-white transition hover:bg-violet-700"
        >
          <FaSyncAlt />
          Réessayer
        </button>
      </div>
    </div>
  );
}